import { render, staticRenderFns } from "./PerformanceTypeSwitch.vue?vue&type=template&id=1a8851d2&scoped=true&"
import script from "./PerformanceTypeSwitch.vue?vue&type=script&lang=js&"
export * from "./PerformanceTypeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceTypeSwitch.vue?vue&type=style&index=0&id=1a8851d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8851d2",
  null
  
)

export default component.exports